import React from "react";
import middleware from "./middlewares/middleware";
import ReportCampaign from "../component/sections/report/ReportCampaign";
import ReportCampaignUser from "../component/sections/report/manage/ReportCampaignUser";
import ReportCampaignUserCustomer from "../component/sections/report/coworker/ReportCampaignUserCustomer";

const reportRoutes = [
  {
    path: "/report/campaign",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ReportCampaign />,
        "ReportCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/report/manage/campaign/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ReportCampaignUser />,
        "ReportCampaignUser"
      );
    },
    exact: true,
  },
  {
    path: "/report/coworker/campaign/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ReportCampaignUserCustomer />,
        "ReportCampaignUserCustomer"
      );
    },
    exact: true,
  },
];

export default reportRoutes;
